import React from 'react';
import Link from 'next/link';
import { TrendingUp, Flame, ArrowUp } from 'lucide-react';
import { USERS, getRankMovement, formatNumber } from '@/lib/mockData';

// Top 3 trending: biggest positive rank movement
const trending = USERS?.filter((u) => u?.previousRank - u?.rank > 0)?.sort((a, b) => (b?.previousRank - b?.rank) - (a?.previousRank - a?.rank))?.slice(0, 3);

export default function TrendingNow() {
  return (
    <div>
      <div className="flex items-center gap-3 mb-5">
        <div className="p-2 rounded-lg" style={{ background: 'rgba(34, 197, 94, 0.1)' }}>
          <TrendingUp size={18} style={{ color: 'var(--primary)' }} />
        </div>
        <div>
          <h2 className="text-lg font-bold" style={{ color: 'var(--foreground)' }}>
            Trending Now
          </h2>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
            Biggest rank climbers this week
          </p>
        </div>
      </div>
      <div className="space-y-3">
        {trending?.map((user, idx) => {
          const movement = getRankMovement(user);
          return (
            <Link
              href="/leaderboard"
              key={`trending-${user?.id}`}
              className="flex items-center gap-4 p-4 rounded-xl transition-all duration-200 hover:scale-[1.01] group"
              style={{
                background: 'var(--muted)',
                border: '1px solid var(--border)',
              }}
            >
              {/* Rank badge */}
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0"
                style={{
                  background: idx === 0 ? 'rgba(34,197,94,0.15)' : 'var(--secondary)',
                  color: idx === 0 ? 'var(--primary)' : 'var(--muted-foreground)',
                }}
              >
                #{user?.rank}
              </div>
              {/* Avatar */}
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0"
                style={{ background: user?.avatarColor, color: '#fff' }}
              >
                {user?.initials}
              </div>
              {/* Info */}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold truncate" style={{ color: 'var(--foreground)' }}>
                  {user?.displayName}
                </p>
                <p className="text-xs truncate" style={{ color: 'var(--muted-foreground)' }}>
                  {user?.username} · {formatNumber(user?.score)} pts
                </p>
              </div>
              {/* Movement */}
              <div className="flex flex-col items-end gap-1">
                <div
                  className="flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-bold"
                  style={{
                    background: 'rgba(34, 197, 94, 0.12)',
                    color: 'var(--primary)',
                  }}
                >
                  <ArrowUp size={12} />
                  {movement?.delta} ranks
                </div>
                <div className="flex items-center gap-1">
                  <Flame size={12} style={{ color: '#f97316' }} />
                  <span className="text-xs font-semibold" style={{ color: '#f97316' }}>
                    {user?.streak}d streak
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}